import { combineReducers } from "redux";
import appsetup from "../features/admin/customization/appsetup/Slice";


const customization = combineReducers({
    appsetup: appsetup,
})


export default customization;